import { render, staticRenderFns } from "./newExtractionScheme.vue?vue&type=template&id=5d3126c2&scoped=true"
import script from "./newExtractionScheme.vue?vue&type=script&lang=js"
export * from "./newExtractionScheme.vue?vue&type=script&lang=js"
import style0 from "./newExtractionScheme.vue?vue&type=style&index=0&id=5d3126c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3126c2",
  null
  
)

export default component.exports